import BodyExerciseFlow from "@/components/Exercises/Body-Exercise/BodyExerciseFlow";
import { Button } from "@/components/ui/button";
import { ExerciseLayout } from "@/components/ui/exercise-layout";
import { createFileRoute } from "@tanstack/react-router";
import { useState } from "react";
import { FormattedMessage } from "react-intl";

export const Route = createFileRoute(
  "/(content)/adults/exercises/(shared)/body-exercise/"
)({
  component: RouteComponent,
  validateSearch: (search: Record<string, unknown>) => ({
    referrer: search?.referrer as string | undefined,
    referrerGroup: search?.referrerGroup as string | undefined,
  }),
  head: () => ({
    meta: [
      {
        title: "Traveling Through Your Body - HAMD",
      },
    ],
  }),
  beforeLoad: () => ({
    title: "stress.exercises.bodyExercise",
    navbar: {
      showTitle: true,
    },
  }),
});

function RouteComponent() {
  const [showOverlay, setShowOverlay] = useState(false);

  const startExercise = () => {
    setShowOverlay(true);
  };

  const closeOverlay = () => {
    setShowOverlay(false);
  };

  return (
    <ExerciseLayout
      contentClassName="py-7.5 space-y-18"
      actions={
        <Button className="w-full" onClick={startExercise}>
          <FormattedMessage id="bodyExercise.startExercise" />
        </Button>
      }
    >
      <p className="text-small text-dark">
        <FormattedMessage id="bodyExercise.intro.text" />
      </p>
      <BodyExerciseFlow onComplete={closeOverlay} onExit={closeOverlay} isShow={showOverlay} />

    </ExerciseLayout>

  );
}
